import React from 'react';
import { motion } from 'framer-motion';
import { FiBookOpen, FiCalendar, FiAward } from 'react-icons/fi';
import { education } from '../data/portfolioData';

const toFileName = (degree) =>
  degree.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '') + '.js';

const Education = () => {
  return (
    <section id="education" className="education">
      <motion.h2
        className="section-comment"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {'// education'}
      </motion.h2>
      <motion.p
        className="section-subtitle"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        My academic background and qualifications
      </motion.p>

      <div className="education-grid">
        {education.map((edu, index) => (
          <motion.div
            className="education-card"
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <div className="edu-file-tab">{toFileName(edu.degree)}</div>
            <div className="edu-card-body">
              <h3 className="edu-degree">
                <FiBookOpen /> {edu.degree}
              </h3>
              <p className="edu-institution">{edu.institution}</p>
              <div className="edu-meta">
                <span className="edu-period">
                  <FiCalendar /> {edu.period}
                </span>
                <span className="edu-grade">
                  <FiAward /> {edu.grade}
                </span>
              </div>
              <p className="edu-description">{edu.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Education;
